// todo, make generic geo element from this.
import { HtmlComponent } from './../../../html-component';
import { Gui } from './../../../../gui';
import { EmployeeDataType } from './../../../../../data-management/data-sources/sources/employees-data-source';
import { MapPopup } from './../map-popup';

// import html
import template from './map-popup-item.hogan.html';

export class MapPopupItem extends HtmlComponent {
    constructor(private gui: Gui, private mapPopup: MapPopup, private item: EmployeeDataType) {
        super(template, { name: item.Name });

        this.jqueryElement.click(event => {
            this.gui.commandManager.selectUserCommandExecutor.requestExecute({
                userId: this.item._internal_datasource_id_
            });
            this.mapPopup.hide();
            event.stopPropagation();
        });
    }
}
